import { render, staticRenderFns } from "./Edit-transferencia.vue?vue&type=template&id=781d6c5b&"
import script from "./Edit-transferencia.vue?vue&type=script&lang=js&"
export * from "./Edit-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./Edit-transferencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports